export default __webpack_public_path__ + "static/media/logo-small.837a655d.svg";